import React, { useState } from 'react';
import { Button, Card, CardContent, Grid, Menu, MenuItem, Popover, Tooltip, Typography } from '@material-ui/core';
import { MoreVert } from '@material-ui/icons';
import moment from 'moment';
import PenToSqauareEditIcon from '../../assets/PenToSquareEditIcon';
import ImageAvatar from '../common/Avatar';

const getLastSeen = (date) => {
  if (date) {
    return `Last Seen ${moment(date, 'YYYY-MM-DD HH:mm:ss').format('DD MMM, YYYY | hh:mm a')}`;
  }
  return <span>&nbsp;</span>;
};

function EmployeeCustomGroupTag({ customGroups = [], classes }) {
  const [anchorEl, setAnchorEl] = useState(null);

  const handlePopoverOpen = (event) => {
    if (anchorEl) handlePopoverClose();
    else setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };
  return (
    <Button onClick={handlePopoverOpen} className={classes.customGroupsBox} variant="text">
      <span className={classes.customGroupsText}>{customGroups.length} Custom Groups</span>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        onClose={handlePopoverClose}
      >
        <Grid container direction="column" style={{ padding: '10px' }}>
          {customGroups.map((i) => (
            <Grid item key={i}>
              <Typography noWrap variant="subtitle2" component="div">
                {i}
              </Typography>
            </Grid>
          ))}
        </Grid>
      </Popover>
    </Button>
  );
}

const EmployeeTags = ({ classes, emp, flow }) => (
  <div className={classes.boxes}>
    <span>
      {emp.enabled ? (
        <div className={classes.enabledBox}>
          <span className={classes.enabledText}>Enabled</span>
        </div>
      ) : (
        <div className={classes.disabledBox}>
          <span className={classes.disabledText}>Disabled</span>
        </div>
      )}
    </span>
    {flow !== 'dealership' ? (
      <EmployeeCustomGroupTag customGroups={emp.customGroups} classes={classes} />
    ) : (
      <>
        {emp.reportingEnabled ? (
          <div className={classes.reAEBox}>
            <Tooltip title="Reporting Enabled">
              <span className={classes.reAEText}>RE</span>
            </Tooltip>
          </div>
        ) : null}
        {emp.enableAssign ? (
          <div className={classes.reAEBox}>
            <Tooltip title="Assignment Enabled">
              <span className={classes.reAEText}>AE</span>
            </Tooltip>
          </div>
        ) : null}
      </>
    )}
  </div>
);

const DealerUserCard = ({ emp, flow, classes }) => (
  <Grid container alignItems="center" justifyContent="space-between" direction="row">
    <Grid item xs className={classes.dealerEmployeeRoleWrapper}>
      <Typography noWrap variant="p">
        {emp.departmentRoleTitle}
      </Typography>
    </Grid>
    <Grid item xs className={classes.dealerEmployeeTagWrapper}>
      <EmployeeTags classes={classes} emp={emp} flow={flow} />
    </Grid>
  </Grid>
);

const RuleUserCard = ({ emp, flow, classes }) => (
  <Grid container justifyContent="space-between" direction="column">
    <Grid item xs>
      <Typography noWrap variant="p">
        {emp.departmentRoleTitle}
      </Typography>
    </Grid>
    <Grid item xs className={classes.ruleEmployeeTagWrapper} style={{ marginTop: '8px' }}>
      <EmployeeTags classes={classes} emp={emp} flow={flow} />
    </Grid>
  </Grid>
);

export default function EmployeeCardItem({ emp, classes, setOpenEditForm, setEditEmployeeHash, flow = 'dealership' }) {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClose = () => {
    setAnchorEl(null);
    setEditEmployeeHash(null);
  };

  const handleClick = (event, hash) => {
    setAnchorEl(event.currentTarget);
    setEditEmployeeHash(hash);
  };

  return (
    <Card className={classes.cardContent}>
      <CardContent>
        <Grid container direction="column">
          <Grid item>
            <Grid container direction="row">
              <Grid item xs={2}>
                <ImageAvatar
                  alt={emp.name}
                  src={emp.profilePic ? emp.profilePic : '/static/images/avatar/1.jpg'}
                  className={classes.avatarStyle}
                />
              </Grid>
              <Grid item xs={8}>
                <Typography noWrap className={classes.primaryText}>
                  {emp.firstName} {emp.lastName}
                </Typography>
                <Typography noWrap className={classes.secondaryLastAccessText}>
                  {getLastSeen(emp.lastActiveDay)}
                </Typography>
              </Grid>
              <MoreVert className={classes.moreIcon} onClick={(e) => handleClick(e, emp.hash)} />
              <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                style={{
                  marginTop: '10px',
                }}
              >
                <MenuItem
                  value="Edit Employee"
                  className={classes.menuRoot}
                  onClick={() => {
                    setAnchorEl(null);
                    setOpenEditForm(true);
                  }}
                >
                  <PenToSqauareEditIcon style={{ height: '16px', width: '16px', marginRight: '10px' }} />
                  <span className={classes.editEmployeeText}>Edit Employee Details</span>
                </MenuItem>
              </Menu>
            </Grid>
          </Grid>
          <Grid item style={{ marginTop: '5px' }}>
            {flow === 'dealership' ? (
              <DealerUserCard emp={emp} flow={flow} classes={classes} />
            ) : (
              <RuleUserCard emp={emp} flow={flow} classes={classes} />
            )}
          </Grid>
          {flow !== 'dealership' ? (
            <Grid item className={classes.dealershipNameContent}>
              <Typography noWrap className={classes.secondaryLastAccessText}>
                Dealership: {emp.dealershipName}
              </Typography>
            </Grid>
          ) : (
            <span className={classes.bottom}></span>
          )}
        </Grid>
      </CardContent>
    </Card>
  );
}
